import ProtectedLgpMemberRoute from "@/components/ProtectedRoutes/ProtectedLgpMemberRoute";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Forms = lazy(() => import("@/pages/agent/tools/forms/Forms/Forms"));
const AddForm = lazy(() => import("@/pages/agent/tools/forms/AddForm/AddForm"));
const EditForm = lazy(() => import("@/pages/agent/tools/forms/EditForm/EditForm"));
const FormResponses = lazy(() => import("@/pages/agent/tools/forms/FormResponses/FormResponses"));

const SpecialOccasions = lazy(() => import("@/pages/agent/tools/special-occasions/SpecialOccasions/SpecialOccasions"));
const EditSpecialOccasions = lazy(
  () => import("@/pages/agent/tools/special-occasions/EditSpecialOccasions/EditSpecialOccasions"),
);
const ManageClients = lazy(() => import("@/pages/agent/tools/special-occasions/clients/ManageClients/ManageClients"));

const LeadsProgram = lazy(() => import("@/pages/agent/tools/leads-program/LeadsProgram/index"));

const LeadDetails = lazy(() => import("@/pages/agent/tools/leads-program/LeadDetails/index"));

const Error404 = lazy(() => import("@/pages/Error404"));

const toolsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  // {
  //   path: "forms",
  //   children: [
  //     {
  //       index: true,
  //       element: <Forms />,
  //     },
  //     {
  //       path: "new",
  //       element: <AddForm />,
  //     },
  //     {
  //       path: ":id",
  //       element: <EditForm />,
  //     },
  //     {
  //       path: ":id/responses",
  //       element: <FormResponses />,
  //     },
  //   ],
  // },
  {
    path: "special-occasions",
    children: [
      {
        index: true,
        // element: <SpecialOccasions />,
        element: <Error404 />,
      },
      {
        path: "edit",
        element: <EditSpecialOccasions />,
      },
      {
        path: "clients",
        children: [
          {
            index: true,
            element: <ManageClients />,
          },
        ],
      },
    ],
  },
  {
    path: "leads-program",

    children: [
      {
        index: true,
        // element: <SpecialOccasions />,
        element: (
          // <ProtectedLgpMemberRoute>
          <LeadsProgram />
          // </ProtectedLgpMemberRoute>
        ),
      },
      {
        path: ":id",
        element: (
          // <ProtectedLgpMemberRoute>
          <LeadDetails />
          // </ProtectedLgpMemberRoute>
        ),
      },
    ],
  },
];

export default toolsRoutes;
